import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "lc_ttop"
};
const _hoisted_2 = {
  class: "lc_cdlj"
};
const _hoisted_3 = {
  style: {
    "padding-bottom": "50px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LcButtons = _resolveComponent("LcButtons");
  const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
  const _component_lcbzyxtable = _resolveComponent("lcbzyxtable");
  const _component_el_input = _resolveComponent("el-input");
  const _component_lcggdytab = _resolveComponent("lcggdytab");
  const _component_lctinymce = _resolveComponent("lctinymce");
  const _component_LcWriteLinks = _resolveComponent("LcWriteLinks");
  const _component_el_main = _resolveComponent("el-main");
  return _openBlock(), _createBlock(_component_el_main, {
    class: "bg_white wrap_box lc_rw"
  }, {
    default: _withCtx(() => [_createVNode(_component_LcButtons, {
      ref: "lcButtons",
      type: 2,
      onBtsEmit: _cache[0] || (_cache[0] = $event => _ctx.btsEmit($event)),
      planStratTime: _ctx.data.baseInfo.plan_start_time_text,
      ids: _ctx.ids,
      projectName: _ctx.data.baseInfo.project_name,
      reviewerUserId: _ctx.data.baseInfo.reviewer_user_id,
      userId: _ctx.data.baseInfo.leader_user_id,
      msg: _ctx.data.baseInfo.msg,
      onGetPageInfo: _ctx.getPageInfo,
      deppgetPageInfo: _ctx.getPageInfo
    }, null, 8, ["planStratTime", "ids", "projectName", "reviewerUserId", "userId", "msg", "onGetPageInfo", "deppgetPageInfo"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_lcBaseInfo, {
      ref: "addBaseInfo",
      type: "taskInfo"
    }, null, 512)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "包装原型", -1)), _createVNode(_component_lcbzyxtable, {
      bzyxTableData: _ctx.data.bzyxTableData,
      "onUpdate:bzyxTableData": _cache[1] || (_cache[1] = $event => _ctx.data.bzyxTableData = $event),
      selectlist: _ctx.data.selectbzyxlist,
      "onUpdate:selectlist": _cache[2] || (_cache[2] = $event => _ctx.data.selectbzyxlist = $event)
    }, null, 8, ["bzyxTableData", "selectlist"]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "lc_title lc_ttop lc_add_ggdyb"
    }, "输出文件", -1)), _createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "title"
    }, "存档路径", -1)), _createVNode(_component_el_input, {
      type: "textarea",
      placeholder: "包装整套文档(包装盒/说明书/纸箱/产品渲染图/包装效果图等)，丝印文档，BOM，存档路径",
      modelValue: _ctx.data.files_text,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.data.files_text = $event),
      class: "lc_bz",
      style: {
        "min-height": "98px"
      },
      maxlength: "500",
      "show-word-limit": ""
    }, null, 8, ["modelValue"])]), _cache[9] || (_cache[9] = _createElementVNode("div", {
      class: "lc_title1"
    }, "规格定义表", -1)), _createVNode(_component_lcggdytab, {
      ggdyTableData: _ctx.data.ggdyTableData,
      "onUpdate:ggdyTableData": _cache[4] || (_cache[4] = $event => _ctx.data.ggdyTableData = $event),
      nobts: ['add', 'delet', 'bzbom'],
      prtaskId: _ctx.ids
    }, null, 8, ["ggdyTableData", "prtaskId"]), _cache[10] || (_cache[10] = _createElementVNode("div", {
      class: "lc_ttop lc_bzt"
    }, "备注", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_lctinymce, {
      id: _ctx.data.id,
      ref: "editor",
      height: _ctx.data.height,
      "cur-value": _ctx.data.remark,
      onInput: _ctx.inputContent,
      key: _ctx.data.key
    }, null, 8, ["id", "height", "cur-value", "onInput"]))]), (_openBlock(), _createBlock(_component_LcWriteLinks, {
      key: _ctx.bzyxpptdata.isShowLinksDialogIndex,
      isShowLinksDialog: _ctx.bzyxpptdata.isShowLinksDialog,
      "onUpdate:isShowLinksDialog": _cache[5] || (_cache[5] = $event => _ctx.bzyxpptdata.isShowLinksDialog = $event),
      onGetDragWriteData: _ctx.getDragWriteData
    }, null, 8, ["isShowLinksDialog", "onGetDragWriteData"]))]),
    _: 1,
    __: [7, 8, 9, 10]
  });
}